import { DataPackGroup } from '../../app/models/dataPackGroup.model';

/**
 * @author Wesley Mascarenhas
 * @version $Id: data.manager.model.ts 79367 2018-02-17 00:41:28Z thiago.h.neri $
 */
export class DataPackUserManagerModel {

  public dataPackGroupList: Array<DataPackGroup>;
  public id: string;
  public name: string;
  public login: string;
  public email: string;
  public telNumber: string;
  public profile: string;
  public sendEmail: boolean;

  public constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/models/data.manager.model.ts